// handleError.js
import axios from 'axios'
import { toast } from 'react-toastify'

const DEFAULT_MESSAGE = 'Ocurrió un error inesperado. Intenta nuevamente.'

export function handleError(error, fallbackMessage = DEFAULT_MESSAGE) {
  const parts = []
  const add = (v) => {
    if (v == null) return
    const s = String(v).trim()
    if (s) parts.push(s)
  }

  if (axios.isAxiosError?.(error)) {
    const res = error.response
    const data = res?.data

    // Mensaje principal
    if (typeof data === 'string') add(data)
    else if (data && typeof data === 'object') {
      if (data.message) add(data.message)

      // Errores detallados (array u objeto)
      const errs = data.errors
      if (Array.isArray(errs)) {
        errs.forEach((it) => {
          if (!it) return
          if (typeof it === 'string') add(it)
          else if (it.message) add(it.message)
          else add(JSON.stringify(it))
        })
      } else if (errs && typeof errs === 'object') {
        Object.entries(errs).forEach(([key, val]) => {
          if (Array.isArray(val)) val.forEach((v) => add(`- ${key}: ${v}`))
          else add(`- ${key}: ${val}`)
        })
      }
    }

    // Fallbacks
    if (parts.length === 0 && error.message) add(error.message)
    if (error.code === 'ERR_NETWORK' && parts.length === 0) {
      add('No hay conexión con el servidor.')
    }
  } else {
    add(error?.message || fallbackMessage)
  }

  const msg = parts.length ? parts.join('\n') : fallbackMessage
  toast.error(msg, { style: { whiteSpace: 'pre-line' } })
}
